(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-rating"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const link = event.target.closest?.('a.ms-review-link');
  if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const destination = new URL(link.href, window.location.href);
  if (destination.pathname !== window.location.pathname) return;
  const reviews = document.getElementById('judgeme_product_reviews');
  if (!reviews) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  reviews.scrollIntoView({ behavior: 'instant', block: 'start' });
}, true);
  } catch(e) { console.error(e); }
})();

})();
